import { PathOptions } from "leaflet";

export const linhas_de_transmissao_expansao_planejada = (feature: any): PathOptions => {
  const vn = Number(feature.properties?.vn);

  // 230 kV - Green (planned)
  if (vn === 230) {
    return {
      color: "#54b04a",
      weight: 2,
      opacity: 1,
      dashArray: "2 7", // Dashed line for planned infrastructure
    };
  }

  // 500 kV - Dark red (planned)
  if (vn === 500) {
    return {
      color: "#db1e2a",
      weight: 2,
      opacity: 1,
      dashArray: "2 7",
    };
  }

  // 600 kV - Yellow (planned)
  if (vn === 600) {
    return {
      color: "rgba(255, 249, 1, 1)",
      weight: 2,
      opacity: 1,
      dashArray: "2 7",
    };
  }

  // Default fallback (shouldn't happen if data is complete)
  return {
    color: "#FFA500",
    weight: 2,
    opacity: 0.7,
    dashArray: "2 7",
  };
};
